export default __webpack_public_path__ + "static/media/shelfie-logo.8c26d14c.svg";